module.exports = __webpack_public_path__ + "static/media/m-mybb.ea82a1d7.svg";